import React, { useState } from 'react'
import DeleteModal from '../../../Components/Admin/shared/DeleteModel';
import TableRow from "../../../Components/Admin/CMS/Services/TableRow";
import EditModal from '../../../Components/Admin/CMS/Services/EditModel';
import AddModal from '../../../Components/Admin/CMS/Services/AddModel';

const rowsText = [
    "Service",
    "Actions",
];

const itemsPerPage = 5;

const Service = () => {
    const [isEdit, setIsEdit] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isAdd, setIsAdd] = useState(false);

    const [idForDelete, setIdForDelete] = useState(0);

    const [InfoForUpdate, setInfoForUpdate] = useState({});

    const [status, setStatus] = useState({
        show: false,
        icon: "success",
        title: "",
        description: "",
        showConfirmButton: true,
        timer: 10000,
    });

    function handleModal(setState, value) {
        setState(value);
    }

    return (
        <div className=' md:p-10  p-4 bg-[#f5f5f5]'>
            <div className='flex justify-end'>
                <button
                    onClick={() => handleModal(setIsAdd, true)}
                    type='button'
                    data-modal-toggle='add-user-modal'
                    className='inline-flex items-center justify-center  px-3 py-2 text-sm font-medium text-center rounded-lg text-primary hover:bg-[#3c2154] hover:text-white    sm:w-auto border-2 border-primary'
                >
                    <svg
                        className='w-6 h-6 mr-2 -ml-1'
                        fill='currentColor'
                        viewBox='0 0 20 20'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            fillRule='evenodd'
                            d='M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z'
                            clipRule='evenodd'
                        />
                    </svg>
                    Add Service
                </button>
            </div>

            <TableRow
                title={"Users Accepting List"}
                setIsEdit={setIsEdit}
                setIsDelete={setIsDelete}
                handleModal={handleModal}
                rows={rowsText}
                itemsPerPage={itemsPerPage}
                setIdUserForDelete={setIdForDelete}
                status={status}
                setStatus={setStatus}
                setInfoForUpdate={setInfoForUpdate}
                url={"CMS/services"}
            />

             <AddModal
                handleModal={handleModal}
                setIsAdd={setIsAdd}
                isAdd={isAdd}
                setStatus={setStatus}
                url={`CMS/services`}
            />

            <EditModal
                handleModal={handleModal}
                setIsEdit={setIsEdit}
                isEdit={isEdit}
                setStatus={setStatus}
                InfoForUpdate={InfoForUpdate}
                url={`CMS/services`}
            />

            <DeleteModal
                handleModal={handleModal}
                setIsDelete={setIsDelete}
                isDelete={isDelete}
                idForDelete={idForDelete}
                setStatus={setStatus}
                url={"CMS/delete-services"}
            /> 
        </div>
    )
}

export default Service;
